module.exports = __webpack_public_path__ + "static/media/barista-illustration-screen.e6927ce1.jpg";